
        var result = require("!!../../../../../node_modules/css-loader/index.js!./integration.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/views/admin/loyalty-site/integration.css
// module id = 1480
// module chunks = 0